import { render, staticRenderFns } from "./AppLogHistory.vue?vue&type=template&id=b54f8526&"
import script from "./AppLogHistory.vue?vue&type=script&lang=js&"
export * from "./AppLogHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports